const menuToggler = document.querySelector('.js-mobile-menu-toggler');
const menu = document.querySelector('.js-mobile-menu');

if (menuToggler) {
    menuToggler.addEventListener('click', function () {
        menuToggler.classList.toggle('open');
        menu.classList.toggle('visible');
        document.querySelector('body').classList.toggle('mobile-menu-open');
    });
}

window.addEventListener('optimizedResize', function() {
    if (window.innerWidth >= 1024) {
        menuToggler.classList.remove('open');
        menu.classList.remove('visible');
        document.querySelector('body').classList.remove('mobile-menu-open');
    }
});

const publicationPage = document.querySelector('article.publication .publication__cover');
if (publicationPage) {
    document.querySelector('header').classList.add('header_no-shadow');
}


const subNavTogglers = document.querySelectorAll('.js-sub-nav-toggler');
if (subNavTogglers) {
    subNavTogglers.forEach(toggler => {
        const subNavWrap = toggler.parentElement;
        let hideTimeout = null;

        toggler.addEventListener('mouseover', function () {
            clearTimeout(hideTimeout);
            showSubNav(toggler);
        });
        toggler.addEventListener('mouseleave', function () {
            clearTimeout(hideTimeout);
            hideTimeout = setTimeout(() => {
                hideSubNav(toggler);
            }, 200);
        });

        subNavWrap.addEventListener('mouseover', function () {
            clearTimeout(hideTimeout);
        });
        subNavWrap.addEventListener('mouseleave', function () {
            clearTimeout(hideTimeout);
            hideTimeout = setTimeout(() => {
                hideSubNav(toggler);
            }, 200);
        });
    });
}

function showSubNav(toggler) {
    const subNavWrap = toggler.parentElement;
    const subNav = subNavWrap.querySelector('.sub-nav');
    subNav.classList.add('visible');
}

function hideSubNav(toggler) {
    const subNavWrap = toggler.parentElement;
    const subNav = subNavWrap.querySelector('.sub-nav');
    subNav.classList.remove('visible');
}